module.exports = __webpack_public_path__ + "img/mlk-day-kindness.7e10e458.png";